import { LOCALE_DIRECTION, type Locale } from '@/lib/locale';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLocale, currentLocale } from '@/lib/i18n';

/**
 * The only supported way to read or change the active locale. Components must
 * not touch i18n.language or document.dir directly, or `dir` and `lang` drift
 * apart from the stored preference.
 */
export function useLocale() {
  const { i18n } = useTranslation();
  const locale = currentLocale();

  const setLocale = useCallback(async (next: Locale) => {
    await changeLocale(next);
  }, []);

  return {
    locale,
    direction: LOCALE_DIRECTION[locale],
    isRtl: LOCALE_DIRECTION[locale] === 'rtl',
    setLocale,
    ready: i18n.isInitialized,
  };
}
